export const ENHANCER_MTCC_FUNC_CODE = '00106';
export const ERASER_MTCC_FUNC_CODE = '00107';
export const MATTING_MTCC_FUNC_CODE = '00102';
export const RETOUCHING_MTCC_FUNC_CODE = '00163';
export const EXPAND_MTCC_FUNC_CODE = '1215';
